import React, { useEffect } from "react";
import "../style/about.scss";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import about1 from "../image/about1.webp";
import about2 from "../image/about2.webp";
import about3 from "../image/about3.webp";
import about from "../image/about.webp";
import row3 from "../image/row3.webp";
import row4_1 from "../image/row4-1.webp";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto text-[14px] leading-10">
        <div>
          <img src={about} alt="" />
        </div>
        <p className="m-0 bg-btn p-10 text-center text-[24px] text-white">
          At Elvorloy, we work with master artisans in La Antigua Guatemala and
          Oaxaca Mexico, to create leather goods that stand apart from the
          mass-produced. Our commitment to premium materials, traditional
          methods, and honest pricing reflects our belief that true craft should
          remain accessible and ethical.
        </p>
        <div className="m-10 grid grid-cols-2 gap-10">
          <div>
            <img src={about1} alt="" />
          </div>
          <div className="flex flex-col items-center justify-center bg-[#edeff0]">
            <div className="w-[400px] text-center">
              <p className="text-[20px]">Our True Value</p>
              <p>
                While other brands inflate prices 4–5x, we keep ours honest. No
                seasonal sales, no fake “compare-at” prices, no shortcuts. Every
                Elvorloy piece is priced to reflect authentic craftsmanship and
                lasting value.
              </p>
            </div>
          </div>
          <div>
            <img src={about2} alt="" />
          </div>
          <div className="flex flex-col items-center justify-center bg-[#edeff0]">
            <div className="w-[400px] text-center">
              <p className="text-[20px]">Generations of Craftsmanship</p>
              <p>
                Our products are crafted from full grain leather, carefully
                shaped, stitched, and fire-branded by artisans whose craft has
                been passed down through generations. These leather goods are
                made to outlast seasons and journeys.
              </p>
            </div>
          </div>
          <div>
            <img src={about3} alt="" />
          </div>
          <div className="flex flex-col items-center justify-center bg-[#edeff0]">
            <div className="w-[400px] text-center">
              <p className="text-[20px]">Proudly Made in Latin America</p>
              <p>
                We choose Guatemala and Mexico, where craftsmanship runs deep.
                Unlike mass-production factories, we prioritize ethical
                workplaces and fair treatment. Keeping production close to home
                reduces shipping times and costs, savings we pass on to you with
                fair, honest pricing.
              </p>
            </div>
          </div>
        </div>
      </div>

      <FooterBar />
    </React.Fragment>
  );
};

export default About;
